import { render, staticRenderFns } from "./users-component.vue?vue&type=template&id=54a8510a&scoped=true"
import script from "./users-component.vue?vue&type=script&lang=js"
export * from "./users-component.vue?vue&type=script&lang=js"
import style0 from "./users-component.vue?vue&type=style&index=0&id=54a8510a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8510a",
  null
  
)

export default component.exports